import { render, staticRenderFns } from "./growUp.vue?vue&type=template&id=56cbc9f4&scoped=true"
import script from "./growUp.vue?vue&type=script&lang=js"
export * from "./growUp.vue?vue&type=script&lang=js"
import style0 from "./growUp.vue?vue&type=style&index=0&id=56cbc9f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cbc9f4",
  null
  
)

export default component.exports